import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';

import { AppConfigurator } from '../../../layout/component/app.configurator';
import { LandingLanguage, LandingText } from '../landing.types';
import { LandingLogo } from './landing-logo.component';

@Component({
    selector: 'app-landing-header',
    standalone: true,
    imports: [CommonModule, RouterModule, ButtonModule, RippleModule, OverlayPanelModule, StyleClassModule, AppConfigurator, LandingLogo],
    templateUrl: './landing-header.component.html',
    styleUrl: './landing-header.component.scss'
})
export class LandingHeader {
    private readonly document = inject(DOCUMENT);

    readonly text = input.required<LandingText>();
    readonly language = input.required<LandingLanguage>();
    readonly isDarkTheme = input.required<boolean>();
    readonly activeSection = input.required<string>();

    readonly languageChange = output<LandingLanguage>();
    readonly themeToggle = output<void>();
    readonly navigate = output<string>();

    skipToContent(event: Event): void {
        // Move focus directly instead of following the href, so the URL never picks up a # fragment.
        event.preventDefault();
        this.document.getElementById('landing-main-content')?.focus();
    }
}
